import LoginRepository from "./LoginRepository";
import RecoverPassword from "./RecoverPassword";
import ResendToken from "./TokenService";
import Register from "./RegistroRepository";
import Configuration from "./ConfigurationRepository";
import Clientes from "./ClientesRepositoory";
import Disponibilidad from "./DisponibilidadRepository";
import Auditoria from "./AuditoriaRepository";
import Autorizaciones from "./AutorizacionesRepository";
import Retiro from "./RetiroRepository";

const repositories = {

    login : LoginRepository,
    recoverpass: RecoverPassword,
    resendToken: ResendToken,
    registro: Register,
    config:Configuration,
    clientes:Clientes,
    disponibilidad:Disponibilidad,
    auditoria: Auditoria,
    autorizaciones: Autorizaciones,
    retiro: Retiro,
}
export const RepositoryFactory = {
    get: name => repositories[name]
};